import ChartConfigBuilder from './chart-config-builder';
import DataLabelsConfigBuilder from './data-labels-config-builder';
import ColorsConfigBuilder from './colors-config-builder';
import StrokeConfigBuilder from './stroke-config-builder';
import MarkersConfigBuilder from './markers-config-builder';
import XAxisConfigBuilder from './x-axis-config-builder';
import YAxisConfigBuilder from './y-axis-config-builder';
import TooltipConfigBuilder from './tooltip-config-builder';
import LegendConfigBuilder from './legend-config-builder';

const ChartPropertyKey = {
  Chart: 'chart',
  DataLabels: 'dataLabels',
  Colors: 'colors',
  Stroke: 'stroke',
  Markers: 'markers',
  XAxis: 'xaxis',
  YAxis: 'yaxis',
  Tooltip: 'tooltip',
  Legend: 'legend',
};

export default class ChartDataBuilder {
  #config = {
    [ChartPropertyKey.Chart]: new ChartConfigBuilder(),
    [ChartPropertyKey.DataLabels]: new DataLabelsConfigBuilder(),
    [ChartPropertyKey.Colors]: new ColorsConfigBuilder(),
    [ChartPropertyKey.Stroke]: new StrokeConfigBuilder(),
    [ChartPropertyKey.Markers]: new MarkersConfigBuilder(),
    [ChartPropertyKey.XAxis]: new XAxisConfigBuilder(),
    [ChartPropertyKey.YAxis]: new YAxisConfigBuilder(),
    [ChartPropertyKey.Tooltip]: new TooltipConfigBuilder(),
    [ChartPropertyKey.Legend]: new LegendConfigBuilder(),
  };

  setChartConfig(callback) {
    return this.#setConfigUsingBuilder(ChartPropertyKey.Chart, callback);
  }

  setColorsConfig(callback) {
    return this.#setConfigUsingBuilder(ChartPropertyKey.Colors, callback);
  }

  setStrokeConfig(callback) {
    return this.#setConfigUsingBuilder(ChartPropertyKey.Stroke, callback);
  }

  setXAxisConfig(callback) {
    return this.#setConfigUsingBuilder(ChartPropertyKey.XAxis, callback);
  }

  setYAxisConfig(callback) {
    return this.#setConfigUsingBuilder(ChartPropertyKey.YAxis, callback);
  }

  build() {
    return Object.entries(this.#config).reduce((acc, [key, value]) => ({
      ...acc,
      [key]: value.build(),
    }), {});
  }

  #setConfigUsingBuilder(key, callback) {
    callback(this.#config[key]);

    return this;
  }
}
